import { render, staticRenderFns } from "./importJsonModal.vue?vue&type=template&id=2f2a6124"
import script from "./importJsonModal.vue?vue&type=script&lang=js"
export * from "./importJsonModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports